
import React from "react";
import { LeadStatus } from "./LeadStatus";
import { LeadInvestmentBadge } from "./LeadInvestmentBadge";

interface LeadCardHeaderProps {
  fullName: string;
  email: string;
  status: string;
  investmentRange: string;
  investmentExperience?: string;
}

export const LeadCardHeader = ({ fullName, email, status, investmentRange, investmentExperience }: LeadCardHeaderProps) => {
  return (
    <div className="flex flex-col space-y-1 w-full">
      <div className="flex justify-between items-start w-full">
        <h3 className="font-medium text-sm truncate max-w-[60%]">
          {fullName}
        </h3>
        
        <div className="flex-shrink-0 flex items-center gap-1">
          <LeadStatus status={status} />
          {investmentRange && (
            <LeadInvestmentBadge investmentRange={investmentRange} />
          )}
        </div>
      </div>
      
      {email && (
        <p className="text-xs text-muted-foreground truncate w-full">
          {email}
        </p>
      )}
      
      {/* Removed the investment experience section */}
    </div>
  );
};
